import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  Creditv1m3yq08fl3i as Credit,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { BaseTextInputDialog2ylbln5rtv3j3 as BaseTextInputDialog } from './TextInputDialog.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from './GenericConfirmationDialog.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { bodyBold2czwdzwknab0k as bodyBold } from '../theming/Titles.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { MonetaryValueInput2lk8s753hzo22 as MonetaryValueInput } from '../components/MonetaryValueInput.mjs';
import { zeroToNull11q39tqjxlqyg as zeroToNull } from '../../utils/utils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, it, $completion) {
  if (it) {
    var tmp = $this.fia_1.eia_1.f2();
    var tmp0_elvis_lhs = tmp == null ? null : tmp.y5r_1;
    var tmp_0;
    var tmp_1 = tmp0_elvis_lhs;
    if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp_2 = $this.fia_1.dia_1(new (Credit())(tmp_0, VOID, VOID, VOID, VOID, $this.fia_1.sgs_1.f2()), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    get_dialogStack().wgg();
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.gia_1.iia($this.hia_1, true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function AddCreditDialog$submit$lambda($this$GenericConfirmationDialog) {
  get_dialogStack().pgd();
  return Unit_instance;
}
var AddCreditDialog$submit$slambdaClass;
function AddCreditDialog$submit$slambda() {
  if (AddCreditDialog$submit$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.fia_1 = this$0;
      }
      egk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AddCreditDialog$submit$slambdaClass = $;
  }
  return AddCreditDialog$submit$slambdaClass;
}
function AddCreditDialog$submit$slambda_0(this$0) {
  var i = new (AddCreditDialog$submit$slambda())(this$0);
  var l = (it, $completion) => i.egk(it, $completion);
  l.$arity = 1;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var AddCreditDialog$submitButton$slambdaClass;
function AddCreditDialog$submitButton$slambda() {
  if (AddCreditDialog$submitButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.gia_1 = this$0;
        this.hia_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AddCreditDialog$submitButton$slambdaClass = $;
  }
  return AddCreditDialog$submitButton$slambdaClass;
}
function AddCreditDialog$submitButton$slambda_0(this$0, $$this$button) {
  var i = new (AddCreditDialog$submitButton$slambda())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var AddCreditDialogClass;
function AddCreditDialog() {
  if (AddCreditDialogClass === VOID) {
    class $ extends BaseTextInputDialog() {
      constructor(maxAllowed, header, message, submit) {
        super(header, message, 'Issue Credit', VOID, VOID, 'Reason for giving this credit (optional)', VOID, false);
        this.cia_1 = maxAllowed;
        this.dia_1 = submit;
        this.eia_1 = Signal().hak(null);
      }
      iia(_this__u8e3s4, confirmed, $completion) {
        if (confirmed) {
          var tmp = get_dialogStack();
          var tmp_0 = this.eia_1.f2();
          var tmp0_elvis_lhs = tmp_0 == null ? null : tmp_0.y5r_1;
          var tmp_1;
          var tmp_2 = tmp0_elvis_lhs;
          if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
            tmp_1 = Companion_instance.m62(0);
          } else {
            tmp_1 = tmp0_elvis_lhs;
          }
          var tmp_3 = 'Confirm that you want to issue this credit to the client. This will lower the price of the project by ' + MonetaryValue__toString_impl_xslc77(tmp_1) + ' and cannot be undone.';
          var tmp_4 = AddCreditDialog$submit$lambda;
          tmp.zgd(new (GenericConfirmationDialog())('Issue Credit?', tmp_3, VOID, 'Issue Credit', VOID, VOID, VOID, VOID, tmp_4, VOID, AddCreditDialog$submit$slambda_0(this)));
        } else {
          get_dialogStack().pgd();
        }
      }
      jia(_this__u8e3s4) {
        var tmp = get_primaryButton(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Button())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        var tmp_0 = KMutableProperty0();
        var tmp_1 = Button$_get_enabled_$ref_61t7nx(view);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz(view));
        reactiveScope(view, ($this$reactiveScope) => {
          // Inline function 'kotlin.let' call
          var tmp = $this$reactiveScope.daj(this.eia_1);
          var it = tmp == null ? null : tmp.y5r_1;
          var tmp_0;
          var tmp_1;
          var tmp_2 = it;
          if (!((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null)) {
            tmp_1 = MonetaryValue__compareTo_impl_w7ul1r(it, Companion_instance.r91(0n)) > 0;
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = MonetaryValue__compareTo_impl_w7ul1r(this.cia_1, it) >= 0;
          } else {
            tmp_0 = false;
          }
          var tmp$ret$2 = tmp_0;
          this_0.set(tmp$ret$2);
          return Unit_instance;
        });
        specCenteredText(view, this.mgs_1);
        onClick(view, this.mgs_1, VOID, AddCreditDialog$submitButton$slambda_0(this, view));
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
      wd6(_this__u8e3s4) {
        return this.nia(_this__u8e3s4, ($this$dialogCol) => {
          this.kia($this$dialogCol);
          this.lia($this$dialogCol);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$dialogCol.pc());
          var tmp0_elvis_lhs = $this$dialogCol.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$dialogCol : tmp0_elvis_lhs;
          $this$dialogCol.gbb(p, view);
          view.zbm(true);
          // Inline function 'com.crowpay.views.components.requiredField' call
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(true);
          view_0.bb9(get_AppDimensions().pg2_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.gbb(p_1, view_1);
          view_1.zbm(false);
          view_1.bb9(get_AppDimensions().rg2_1);
          view_1.lbb(get_centered(view_1), bodyBold(view_1, 'Amount'));
          view_1.lbb(colored(view_1, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_1, '*'));
          view_0.hbb(p_1, view_1);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = view_0.jbb(FieldSemantic_getInstance());
          var tmp_0 = get_compact(view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_2 = view_0.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
          view_0.gbb(p_2, view_2);
          view_2.zbm(false);
          var tmp_1 = get_expanding(view_2);
          // Inline function 'com.crowpay.views.components.monetaryValueInput' call
          // Inline function 'kotlin.also' call
          var this_0 = new (MonetaryValueInput())(view_2);
          this_0.vcl('Maximum ' + MonetaryValue__toString_impl_xslc77(this.cia_1));
          view_2.zah(this_0.ig9_1, zeroToNull(this.eia_1));
          var tmp$ret$7 = this_0.lg9_1;
          view_2.lbb(tmp_1, tmp$ret$7);
          view_0.hbb(p_2, view_2);
          var tmp$ret$12 = view_0.lbb(tmp_0, view_2);
          view_0.lbb(tmp, tmp$ret$12);
          view.hbb(p_0, view_0);
          this.mia(view);
          $this$dialogCol.hbb(p, view);
          this.ei5($this$dialogCol);
          return Unit_instance;
        });
      }
    }
    initMetadataForClass($, 'AddCreditDialog', VOID, VOID, VOID, [2]);
    AddCreditDialogClass = $;
  }
  return AddCreditDialogClass;
}
function AddProjectCreditDialog(project, items) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.y91()) {
      destination.v(element);
    }
  }
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var sum = Companion_instance.r91(0n);
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp = sum;
    var tmp$ret$3 = element_0.q91();
    sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$3);
  }
  var tmp_0 = sum;
  return new (AddCreditDialog())(tmp_0, 'Project Credit', 'Enter credit to be issued for project. Credit will be allocated proportionally across all work items.', AddProjectCreditDialog$slambda_0(project));
}
function AddWorkItemCreditDialog(item) {
  var tmp = item.q91();
  var tmp_0 = "Credit for '" + item.w91() + "'";
  var tmp_1 = 'Enter credit to be issued to ' + item.w91() + '.';
  return new (AddCreditDialog())(tmp, tmp_0, tmp_1, AddWorkItemCreditDialog$slambda_0(item));
}
function *_generator_invoke__zhh2q8_1($this, credit, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfw().rfg_1.yfo($this.qia_1.v7a_1, credit, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var AddProjectCreditDialog$slambdaClass;
function AddProjectCreditDialog$slambda() {
  if (AddProjectCreditDialog$slambdaClass === VOID) {
    class $ {
      constructor($project) {
        this.qia_1 = $project;
      }
      ria(credit, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, credit), $completion);
      }
      s2(p1, $completion) {
        return this.ria(p1 instanceof Credit() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AddProjectCreditDialog$slambdaClass = $;
  }
  return AddProjectCreditDialog$slambdaClass;
}
function AddProjectCreditDialog$slambda_0($project) {
  var i = new (AddProjectCreditDialog$slambda())($project);
  var l = (credit, $completion) => i.ria(credit, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, credit, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfw().gfg_1.kfm($this.sia_1.e6k_1, credit, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var AddWorkItemCreditDialog$slambdaClass;
function AddWorkItemCreditDialog$slambda() {
  if (AddWorkItemCreditDialog$slambdaClass === VOID) {
    class $ {
      constructor($item) {
        this.sia_1 = $item;
      }
      ria(credit, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, credit), $completion);
      }
      s2(p1, $completion) {
        return this.ria(p1 instanceof Credit() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AddWorkItemCreditDialog$slambdaClass = $;
  }
  return AddWorkItemCreditDialog$slambdaClass;
}
function AddWorkItemCreditDialog$slambda_0($item) {
  var i = new (AddWorkItemCreditDialog$slambda())($item);
  var l = (credit, $completion) => i.ria(credit, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  AddProjectCreditDialog as AddProjectCreditDialog2vna8ff6u799p,
  AddWorkItemCreditDialog as AddWorkItemCreditDialog1hq298k1vgsaa,
};
//endregion

//# sourceMappingURL=CreditDialogs.mjs.map
